<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :header="'Build 360 Reports'">
          <el-form label-width="160px" :model="form" ref="add360">
            <div v-if="step == 1" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Introduction</h5>
                  <p>This builds out your 360 reports.</p>
                  <p>We allow you to select any of the completed names of a grouped 360 package to compile your 360 report.</p>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>

            <!-- Step 2 -->
            <div v-if="step == 2" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Group Selection</h5>
                  <p>Select a group to expand into a report.</p>
                  <!-- <select v-model="form.group">
                    <option
                      v-for="c in getPackageList360"
                      :value="c.id"
                      :key="c.$index"
                    >{{c.block_name}}</option>
                  </select>-->
                  <el-select
                    v-model="form.group"
                    filterable
                    default-first-option
                    style="width:100%;"
                    placeholder="Choose the group to build the report with"
                  >
                    <el-option
                      v-for="c in getPackageList360"
                      :key="c.id"
                      :label="c.block_name + ' ( Total: '+c.user_count+', Used: ' + c.used_count + ' )'"
                      :value="c.id"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 3 -->
            <div v-if="step == 3" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>Please use the form below to select the target:</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20" v-for="n in packageNames" :key="n.id">
                    <el-radio
                      v-if="n.tests > 0"
                      v-model="form.target"
                      :label="n.id"
                    >{{ n.name }} {{ n.id }}</el-radio>
                  </el-row>
                </el-col>
              </el-row>
              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 4 -->
            <div v-if="step == 4" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <p>Please use the form below to select the names to include in the report:</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20" v-for="n in packageNames" :key="n.id">
                    <el-checkbox
                      v-if="n.tests > 0 && form.target != n.id"
                      v-model="form.names[n.id]"
                    >{{ n.name }}</el-checkbox>
                  </el-row>
                </el-col>
              </el-row>
              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 5 -->
            <div v-if="step == 5" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Comments</h5>
                  <p>Select the comments, or edit the ones you want to change prior to the report being generated.</p>
                  <div v-for="id in getSelectedIds" :key="id">
                    Comments ({{ id }}):
                    <br />
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="No notes we're left"
                      v-model="form.notes"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 6 -->
            <div v-if="step == 6" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Report Name</h5>
                  <p>Choose a report name which will be easy for you to identify this package later to generate reports.</p>
                  <el-form-item label="Name:" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button :disabled="form.name === ''" @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 7 -->
            <div v-if="step == 7" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Review</h5>
                  <p>Please review the following.</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Number of Candidates:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{getSelectedIds.length}}</p>
                </el-col>
              </el-row>

              <p>&nbsp;</p>
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="12" class="text-right">
                      <el-button @click="next()">Next</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>

            <!-- Step 8 - Done -->
            <div v-if="step == 8" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Complete</h5>
                  <p>View all reports</p>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../../shared/axios';
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../../shared/unserialize.js';
import { basePath } from '../../../shared/basePath';
import { setTimeout } from 'timers';
import { isNumber } from 'util';

export default {
  computed: {
    ...mapGetters('auth', ['getToken', 'getCompanyName']),
    ...mapGetters('packages', ['getPackageList360']),
    ...mapGetters('tests', ['getTestNameById']),
    getFileUploadHeaders() {
      const split = ' ';
      const headerKey = 'Bearer';
      return {
        authorization: headerKey + split + String(this.getToken)
      };
    },
    getSelectedIds() {
      const leIds = [];
      for (const inc in this.form.names) {
        if (
          inc != undefined &&
          this.form.names[inc] != undefined &&
          this.form.names[inc] != null
        ) {
          leIds.push(inc);
        }
      }
      console.log(leIds);
      return leIds;
    }
  },
  data() {
    return {
      basePath: basePath(),
      step: 1,
      form: {
        group: undefined,
        name: '',
        target: 0,
        names: [],
        notes: [],
        testId: 0
      },
      packageNames: []
    };
  },
  watch: {
    step(n) {
      if (n === 3) {
        this.list360PackageDetails();
      }
      if (n === 7) {
        this.saveNewReport();
      }
    }
  },
  created() {
    const p = [];
    p.push(this.fetchTests());
    p.push(this.fetchPackageList360());
    Promise.all(p).then(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions('packages', ['fetchPackageList360']),
    ...mapActions('tests', ['fetchTests']),
    async list360PackageDetails() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      let packageNames = [];
      const packageDetails = await axios.get('/360/list/' + this.form.group);
      const deliverable = Object.assign({}, packageDetails.data.data[0]);
      for (const leId in deliverable.refactoredIds) {
        const leComments = [];
        const leUser = await axios.get(
          'packages/user/' + deliverable.refactoredIds[leId]
        );
        const leUserDemo = await axios.get(
          'user/demo/' + deliverable.refactoredIds[leId]
        );
        console.log(leUserDemo.data);
        const userData = leUser.data.deliverable;
        if (userData.tests.length > 0) {
          try {
            const questions = unserialize(userData.tests[0].raw_items);
            for (const leQuestion in questions) {
              if (leQuestion.indexOf('_') > -1) {
                const questionNumber = parseInt(leQuestion.split('_')[1], 10);
                const questionItem = await axios.get(
                  '/360/question/' +
                    userData.tests[0].test_id +
                    '/' +
                    questionNumber
                );
                this.form.testId = userData.tests[0].test_id;
                if (
                  questions[leQuestion] != null &&
                  questions[leQuestion] != undefined &&
                  !isNumber(questions[leQuestion]) &&
                  questions[leQuestion].length > 2
                ) {
                  leComments.push({
                    number: questionNumber,
                    item: questionItem.data.question,
                    comment: questions[leQuestion]
                  });
                }
              }
              // console.log(leQuestion);
            }
          } catch (e) {
            console.log('errors', e);
          }
        }

        packageNames.push({
          id: userData.general_id,
          name: userData.first_name + '  ' + userData.last_name,
          tests: userData.tests.length,
          comments: leComments,
          relationships: leUserDemo.data.user.demo_data_38,
          ratee: leUserDemo.data.user.demo_data_37
        });
      }
      loading.close();
      this.packageNames = Object.assign([], packageNames);
    },
    getPackageNameById(id) {
      for (const inc in this.packageNames) {
        if (this.packageNames[inc].id === id) {
        }
      }
    },
    async saveNewReport() {
      this.form.refactoredNames = this.getSelectedIds;
      delete this.form.names;
      console.log(this.form);
      const report = await axios.post('/360/report', this.form);
      console.log(report);
    },
    previous() {
      this.step -= 1;
    },
    next() {
      this.step += 1;
    }
  }
};
</script>